import { makeReduxActiveMessage } from '~/main/factories/usecases/message/Update';

/**
 * Close modal updating redux 'message' state
 * @return void
 */
export const closeModal = (): void => {
  makeReduxActiveMessage().active({ active: 'none' });
};
